<ul class="info-header">
  <li>
    <label class="text-bold">{{ 'feed-advice-report.feedadvicename' | translate }}:</label>
    <label class="wide-label">{{ advice?.name }}</label>
  </li>
  <li *ngIf="customer$ | async as customer">
    <label class="text-bold">{{ 'feed-advice-report.farmcompany' | translate }}:</label>
    <label class="wide-label">
      {{ customer?.name }}, {{ customer?.street }} {{ customer?.houseNumber }}
      {{ customer?.houseNumberAddition }},
      {{ customer?.city }}
    </label>
  </li>
  <li *ngIf="location$ | async as location">
    <label class="text-bold">{{ 'feed-advice-report.location' | translate }}:</label>
    <label class="wide-label">
      {{ location?.name }}, {{ location?.street }} {{ location?.houseNumber }}
      {{ location?.houseNumberAddition }},
      {{ location?.city }}
    </label>
  </li>
  <li>
    <label class="text-bold">{{ 'feed-advice-report.contactperson' | translate }}:</label>
    <label>{{ advice?.advisorName }}</label>
  </li>
  <li>
    <ng-container *ngIf="advice?.feedAdviceType === 'SowsBreedToFarrow' && advice?.bodyCondition">
    </ng-container>
    <ng-container *ngIf="advice?.feedAdviceType === 'SowsFarrowToWean'">
      <label class="text-bold">{{
        'feed-advice-detail.piglets-per-farrowing-category' | translate
      }}</label>
      <label>{{ advice.pigletsPerFarrowingCategory }}</label>
    </ng-container>
  </li>
  <li>
    <ng-container *ngIf="advice?.geneticLine">
      <label class="text-bold">{{ 'feed-advice-detail.geneticline' | translate }}</label>
      <label>{{ advice.geneticLine }}</label>
    </ng-container>
  </li>
  <li>
    <label class="text-bold">{{ 'feed-advice-report.remarks' | translate }}:</label>
    <label class="wide-label">{{ advice?.description }}</label>
  </li>
</ul>
